<div
    *ngIf="service.bar$ | async as item"
    class="t-wrapper"
    @tuiParentAnimation
>
    <div
        automation-id="tui-table-bar__bar"
        class="t-bar"
        [@tuiSlideInTop]="animation"
        [class.t-bar_light]="item.mode === 'onDark'"
    >
        <div
            class="t-container"
            [class.t-container_adaptive]="item.adaptive"
        >
            <div class="t-inner">
                <div class="t-content">
                    <!-- TODO: Polymorpheus fix type -->
                    <ng-container *polymorpheusOutlet="$any(item.content) as text; context: getItemContext(item)">
                        {{ text }}
                    </ng-container>
                </div>

                <button
                    *ngIf="item.hasCloseButton"
                    appearance="icon"
                    automation-id="tui-table-bar__close-button"
                    size="xs"
                    tuiIconButton
                    type="button"
                    class="t-close-button"
                    [icon]="icons.close"
                    [title]="closeWord$ | async"
                    [tuiMode]="getMode(item.mode)"
                    (click)="onCloseClick(item)"
                ></button>
            </div>
        </div>
    </div>
</div>
